import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import "rxjs/add/operator/toPromise";
import { LocalService } from "app/services/local.service";

@Injectable({
  providedIn: "root",
})
export class RoleBasedAdminService {
  apiUrl = "";
  // localStorage.getItem("client") &&
  // JSON.parse(localStorage.getItem("client")) &&
  // JSON.parse(localStorage.getItem("client"))["apiUrl"]
  //   ? JSON.parse(localStorage.getItem("client"))["apiUrl"]
  //   : environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }

roleList(page?:number, limit?:number): Promise<any> {
  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  return this.http
    .get(
      `${this.apiUrl}api/roles?page=${page}&limit=${limit}`,
      { headers }
    )
    .toPromise();
}

  deleteRole(id: string,): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http
      .delete(this.apiUrl + "api/roles/" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }



updateRole(id: string, data: any): Promise<any> {

  const headers = new HttpHeaders({
    "Content-Type": "application/json",
     Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  return this.http
    .put(
      this.apiUrl + "api/roles/" + id,
      data,
      { headers }
    )
    .map((response: any) => response)
    .toPromise();
}
 
 


  getPermissions(): Promise<any> {
  const headers = new HttpHeaders({
      "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  return this.http
    .get(this.apiUrl + 'api/roles/permissions', { headers })
    .toPromise();
}

createRole(data): Promise<any> {

  const headers = new HttpHeaders({
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });
  

  return this.http
    .post(
      this.apiUrl + 'api/roles',
      data,
      { headers }
    )
    .toPromise();

}

getRole(id: string): Promise<any> {

  const headers = new HttpHeaders({
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  return this.http
    .get(
      `${this.apiUrl}api/roles/${id}`,
      { headers }
    )
    .toPromise();
}

searchRoles(name: string): Promise<any> {

  const headers = new HttpHeaders({
    Authorization: `Bearer ${localStorage.getItem('token')}`
  });

  return this.http
    .get(
      `${this.apiUrl}api/roles?search=${name}`,
      { headers }
    )
    .toPromise();
}

getAccessRole(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "aggregator/getRoleAccess", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
}
